import UnitQuiz from './component';

export default () => ({
  path: 'unit-quiz',
  component: UnitQuiz,
});



// WEBPACK FOOTER //
// ./containers/Group/Homework/UnitQuiz/routes.js